<template>
  <section id="home" class="w-full pt-[100px] px-[16px] lg:px-[60px] bg-[#F9C9DB] relative" :style="homeBgStyle">
    <div class="max-w-7xl mx-auto grid gap-6 grid-cols-1 lg:grid-cols-[50%_1fr]">
      <div class="w-full flex flex-col pb-[50px] [@media(max-width:1024px)]:items-center justify-center">
        <div class="[@media(max-width:1024px)]:text-center font-bold text-[36px] italic" style="font-style: italic">
          Your daily companion to seek faith and purpose.
        </div>

        <div class="[@media(max-width:1024px)]:text-center mt-[16px] text-[16px] text-[#777777] leading-[26px]">
          From prayer to connection, it helps you grow spiritually<br />
          and find encouragement in every season of life.
        </div>
        <img class="mt-[30px] w-[120px] h-[36px] cursor-pointer" src="@/assets/imgs/download.png" alt="download" @click="handleDownLoadIos()" />
      </div>
      <img class="w-full [@media(max-width:1024px)]:hidden self-end" src="@/assets/imgs/home/home_phone.png" alt="download" />
    </div>

    <img class="absolute bottom-[-1px] right-0 w-full" src="@/assets/imgs/bl4.png" alt="decor" />
  </section>
</template>
<script setup lang="ts">
import { sendTA } from '@/assets/js/TA'
import homeBg from '@/assets/imgs/home/home_bg.png'
import { computed } from 'vue'

const homeBgStyle = computed(() => ({
  backgroundImage: `url(${homeBg})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center right',
  backgroundSize: 'contain',
}))

const handleDownLoadIos = () => {
  sendTA('XWEB_CLICK', {
    name: 'android_download_click',
  })
  window.open('https://play.google.com/store/apps/details?id=com.liotek.lannbible', '_blank')
}
</script>
